import { t, useI18n } from "@bookingcom/lingojs-react";
import useATOL from "../../../../../../../hooks/useATOL.js";
const useAtolInfoController = (flight) => {
    const i18n = useI18n();
    const { isATolProtectedFD } = useATOL();
    const isAtol = isATolProtectedFD(flight);
    return {
        header: i18n.trans(t("flights_atol_details_header")),
        atolText: isAtol ? i18n.trans(t("flights_atol_details_description")) : undefined
    };
};
export default useAtolInfoController;
